import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export function ConnectionFilled() {
  return (
    <SvgIcon>
      <path d="M22 11V3H15V6H9V3H2V11H9V8H11V18H15V21H22V13H15V16H13V8H15V11H22Z" fill="currentColor" />
    </SvgIcon>
  );
}
